import { DownloadOutlined } from "@ant-design/icons";
import { Button, Descriptions, Table, Tabs } from "antd";
import DescriptionsItem from "antd/es/descriptions/Item";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axiosInstance from "../common/api";
import { downloadFile } from "../common/common";

const columns = [
  {
    key: "sku",
    dataIndex: ["product", "description"],
    title: "Prodotto",
    width: 250,
  },
  {
    key: "serial",
    dataIndex: ["inventoryUnit", "serialNumber"],
    title: "Prodotto",
    width: 250,
  },
  {
    key: "amount",
    dataIndex: "amount",
    title: "Quantità",
    width: 100,
  },
];

export default function () {
  const [data, setData] = useState({});
  const [loaing, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`dpiTransaction/${id}`)
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Descriptions layout="vertical" colon={false} column={3}>
        <DescriptionsItem label="Data">{data.date}</DescriptionsItem>
        <DescriptionsItem label="Causale">{data.reason?.reason}</DescriptionsItem>
        <DescriptionsItem label="Dipendente">
          {data.employee?.lastName} {data.employee?.firstName}
        </DescriptionsItem>
        <DescriptionsItem label="Note" span={3}>
          {data.notes}
        </DescriptionsItem>
        <DescriptionsItem label="Note" span={3}>
          {data.createdBy?.lastName} {data.createdBy?.firstName}
        </DescriptionsItem>
        <DescriptionsItem label="Allegato">
          {data.reportRef && (
            <Button
              icon={<DownloadOutlined />}
              onClick={() => downloadFile(`dpiTransaction/${id}/report`)}
            >
              Scarica
            </Button>
          )}
        </DescriptionsItem>
      </Descriptions>
      <Tabs
        style={{ marginTop: 20 }}
        items={[
          {
            key: "lines",
            label: "Righe",
            children: (
              <Table
                columns={columns}
                rowKey="id"
                dataSource={data.lines ?? []}
                bordered
                tableLayout="fixed"
              />
            ),
          },
        ]}
      />
    </>
  );
}
